import { boot } from 'quasar/wrappers';

export default boot(({ app, store }) => {
    const emitter = new EventTarget();
    injectEmitterToApp(app, emitter);
    injectEmitterToPinia(store, emitter);
});

function injectEmitterToApp(app, emitter) {
    app.config.globalProperties.$event = emitter;
    app.provide('$event', emitter);
}

function injectEmitterToPinia(store, emitter) {
    store.use(() => ({ $event: emitter }));
    store.$event = emitter;
    for (const state of Object.keys(store.state.value)) {
        const childStore = store._s.get(state);
        if (!childStore) continue;
        childStore.$event = emitter;
    }
}
